import React, { Fragment, Component } from 'react';
import Select from 'react-select3';
import PropTypes from 'prop-types';
import request from 'superagent';
import { ProgressBar } from 'react-bootstrap';
import { notify } from 'common/Notification';
import "./UploadFolderTree.less";

export default class UploadFolderTree extends Component {
  static defaultProps = {
    connectionId: null,
    casefolderId: null,
    parentFolderId: null,
    pathToFolder: [],
  };

  static propTypes = {
    connectionId: PropTypes.number.isRequired,
    casefolderId: PropTypes.number.isRequired, // FIXME: we get number-as-string instead of number from backend?
    parentFolderId: PropTypes.string,
    onFinalValueChange: PropTypes.func,
  };

  state = {
    isLoading: false,
    finalPath: [],
    folderOptions: []
  };

  async componentDidMount() {
    await this.loadFolders();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    // if the parentId changed, clear selected value and reload folders
    if (prevProps.parentFolderId !== this.props.parentFolderId) {
      this.setState({ folderOptions: [], value: null });
      await this.loadFolders();
    }
  }

  onValueChange = (folder) => {
    this.setState({value: folder});

    if (this.props.valueSelected)
      // sub-folder select changed, call the callback, appending current folder to the path
      this.props.valueSelected(this.props.pathToFolder.concat(folder.name));
    else {
      // top level select changed
      const finalPath = [ folder.name ];
      this.setState({finalPath});
      if (this.props.onFinalValueChange)
        this.props.onFinalValueChange(finalPath);
    }
  }

  valueSelected = (newPath) => {
    this.setState({ finalPath: newPath });

    if (this.props.onFinalValueChange)
      this.props.onFinalValueChange(newPath);
  }

  render() {
    if (this.state.isLoading)
      return <ProgressBar now={100} />;

    if (! this.state.folderOptions.length)
      return null;

    // TODO make ul styling prettier
    return (
      <Fragment>
        <div className="upload-folder-tree">
          <Select
            defaultMenuisOpen
            options={this.state.folderOptions}
            isClearable
            simpleValue
            getOptionValue={(folder) => folder.id}
            getOptionLabel={(folder) => folder.name}
            disabled={this.state.isLoading}
            key={this.props.parentFolderId}
            onChange={this.onValueChange}
            value={this.state.value}
            {...this.props}
          />

          {this.state.value &&
            <ul>
              <li>
                <UploadFolderTree
                  defaultMenuisOpen
                  connectionId={this.props.connectionId}
                  casefolderId={this.props.casefolderId}
                  parentFolderId={this.state.value.id}
                  pathToFolder={this.props.pathToFolder.concat(this.state.value.name)}
                  valueSelected = {
                    this.props.valueSelected || this.valueSelected
                  }
                />
              </li>
            </ul>
          }
        </div>
      </Fragment>
    );
  }

  async loadFolders() {
    this.setState({isLoading: true});

    const {connectionId, casefolderId} = this.props;

    try {
      const response = await request
        .post(`/rpc/integrations/connections/${connectionId}/casefolders/${casefolderId}/list-folders`)
        .set('Content-Type', 'application/json')
        .send({ parent_id: this.props.parentFolderId });

      this.setState({ folderOptions: response.body.folders });
    }
    catch (e) {
      if (e.response.code !== 404)
        notify.error("Failed to load folder list");
    }
    finally {
      this.setState({isLoading: false});
    }
  }
}




// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/UploadFolderTree.jsx